import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a17fb078"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-main",
  style: {"padding-top":"20px"}
}
const _hoisted_2 = {
  key: 0,
  class: "bread-crumb"
}
const _hoisted_3 = { class: "panel stretch-height" }
const _hoisted_4 = { class: "scroll-gantt" }
const _hoisted_5 = { style: {"position":"relative"} }
const _hoisted_6 = {
  class: "panel stretch-height",
  style: {"padding-bottom":"55px"}
}
const _hoisted_7 = { class: "submit-footer" }
const _hoisted_8 = {
  key: 0,
  class: "blocker"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " No drop pool selected ", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "panel stretch-height" }
const _hoisted_12 = { class: "submit-footer" }
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideNavigation = _resolveComponent("SideNavigation")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_g_gantt_row = _resolveComponent("g-gantt-row")!
  const _component_g_gantt_chart = _resolveComponent("g-gantt-chart")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_PoolEditor = _resolveComponent("PoolEditor")!
  const _component_PoolInfo = _resolveComponent("PoolInfo")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_CreateDropPoolForm = _resolveComponent("CreateDropPoolForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.selectedCampaign)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_SideNavigation),
          _createVNode(_component_a_button, {
            class: "add-drop-pool",
            size: "small",
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createDropPool()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                class: "add-icon",
                icon: "plus",
                style: {"margin-right":"10px"}
              }),
              _createTextVNode("Drop pool")
            ]),
            _: 1
          }),
          (_ctx.selectedDropPool)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Campaigns / " + _toDisplayString(_ctx.selectedCampaign.name) + " " + _toDisplayString(_ctx.selectedDropPool.name ? `/ ${_ctx.selectedDropPool.name}` : ""), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_a_row, {
            gutter: 10,
            style: {"height":"50%","margin-bottom":"10px","overflow":"hidden"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 24,
                style: {"overflow":"hidden"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_g_gantt_chart, {
                          onDragendBar: _cache[1] || (_cache[1] = ($event: any) => (
									_ctx.onDragendBar($event.bar, $event.e)
								)),
                          "chart-start": 
									_ctx.moment(_ctx.selectedCampaign.startDate).format(
										'YYYY-MM-DD'
									)
								,
                          "chart-end": 
									_ctx.moment(_ctx.selectedCampaign.endDate).format(
										'YYYY-MM-DD'
									)
								,
                          "date-format": "YYYY-MM-DD",
                          precision: "day",
                          "bar-start": "myBeginDate",
                          "bar-end": "myEndDate"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gantRows, (row, index) => {
                              return (_openBlock(), _createBlock(_component_g_gantt_row, {
                                onMousedown: ($event: any) => (_ctx.selectDropPool(index)),
                                key: index,
                                label: _ctx.getLabel(index),
                                bars: row
                              }, null, 8, ["onMousedown", "label", "bars"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["chart-start", "chart-end"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, {
            gutter: 10,
            style: {"height":"50%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_PoolEditor, { dropPool: _ctx.selectedDropPool }, null, 8, ["dropPool"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_a_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeleteModal = true)),
                        style: {"margin-right":"10px"},
                        type: "default"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Delete")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        loading: _ctx.saving,
                        type: "primary",
                        onClick: _ctx.handleSubmit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Update")
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"])
                    ]),
                    (!_ctx.selectedDropPool)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_PoolInfo)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showDeleteModal,
      title: 'Delete Pool',
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDeleteModal = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          message: "Warning",
          description: "This pool will be removed permanently.",
          type: "warning",
          "show-icon": ""
        }),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_a_button, {
            style: {"margin-right":"10px"},
            type: "default",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeleteModal = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          (_ctx.selectedDropPool)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                disabledtype: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleDelete()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Delete")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      footer: null,
      maskClosable: false,
      visible: _ctx.showModal,
      title: 'Create Pool',
      onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showModal = false))
    }, {
      default: _withCtx(() => [
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_CreateDropPoolForm, {
                dropPool: _ctx.dropPool,
                campaignID: _ctx.selectedCampaign.id,
                onSaved: _ctx.modifiedDropPool
              }, null, 8, ["dropPool", "campaignID", "onSaved"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}